import React, { useState, useEffect, useContext } from 'react';
import { makeStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box';
import { SessionContext } from "../context/session-context";

import Topbar from './PlainTopbar';
import Footer from './PlainFooter';
import Login from './LoginInterface';
import Admin from './AdminInterface';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Snackbar from '@material-ui/core/Snackbar';
import Slide from '@material-ui/core/Slide';
import Alert from '@material-ui/lab/Alert';
import ReactLoading from 'react-loading';

var handleError = function (err) {
  console.log(err);
  return new Response(JSON.stringify({
    code: 400,
    message: 'Stupid network Error'
  }));
};

const useStyles = makeStyles({
  root:{

  },
  actionButton:{
    color: '#FFFFFF',
    backgroundColor: '#29C548',
    '&:hover': {
      color: '#FFFFFF',
      backgroundColor: '#E55300',
    },
    minWidth:120,
    height:32,
  },
  errorTxt:{
    color: '#ff0000',
    fontSize:12
  }
});






export default function MainInterface(props) {

    const classes = useStyles();
    const [state, dispatch] = useContext(SessionContext);
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
      setIsActive(state.isActive)
      //console.log("isActive. "+state.isActive);
      //if (state.isActive === 'true' || state.isActive) { setIsActive(true); console.log("isActive. True"); }else{ setIsActive(false); console.log("isActive. False");}
    },[state.isActive])

    return (
      <div className={classes.root}>
        <Grid container>
          <Grid item xs={12}><Topbar/></Grid>
          <Grid item xs={12}>
            {isActive? (
              <Admin />
            ) : ( 
              <Login />
            )}
            </Grid>
            <Grid item xs={12}><Footer/></Grid>
        </Grid>
      </div>
  
    );
  }